import { Card, CardBody, Row, Col } from "reactstrap";
import { FormattedMessage } from "react-intl";

const StudentSequence = (props) => {
  var studentAnswer = [];
  var correctAnswer = [];

  props.data.studentAnswer.split("[,]").forEach((element, index) => {
    if (index % 2 === 1) {
      studentAnswer.push(element);
    }
  });

  props.data.correctAnswer.split("[,]").forEach((element, index) => {
    if (index % 2 === 1) {
      correctAnswer.push(element);
    }
  });

  return (
    <Card className="h-100 mb-0">
      <CardBody>
        <Row>
          <Col style={{ flex: "0 0 50%" }}>
            <span className="fw-bold">
              <FormattedMessage id="CorrectAnswer" />
            </span>
            {correctAnswer.map((answer, index) => {
              return (
                <div key={"qa" + props.questionIndex + "ca" + index}>
                  {index + 1}.&nbsp;
                  {answer}&nbsp;
                  <br />
                </div>
              );
            })}
          </Col>
          <Col style={{ flex: "0 0 50%" }}>
            <span className="fw-bold">
              <FormattedMessage id="StudentsAnswer" />
            </span>
            {studentAnswer.map((answer, index) => {
              return (
                <div key={"qa" + props.questionIndex + "sa" + index}>
                  {index + 1}.&nbsp;
                  {answer}&nbsp;
                  <br />
                </div>
              );
            })}
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default StudentSequence;
